import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminDashboard from '../components/AdminDashboard';
import { initAppData } from '../services/initService';
import '../styles/variables.css';

export default function DashboardPage() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      await initAppData();
      setReady(true);
    })();
  }, []);

  if (!ready) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--dark)',
        color: 'rgba(255,255,255,0.5)',
        fontSize: '.9rem',
      }}
      >
        Loading…
      </div>
    );
  }

  return <AdminDashboard onExit={() => navigate('/')} />;
}
